import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import BaseSVGIcon from "base/components/BaseSVGIcon";
import Loader from "base/components/Loader";
import { Check } from "@mui/icons-material";
import { ReactComponent as EnglishFlagSVG } from "base/assets/icons/english-flag.svg";
import { ReactComponent as KoreanFlagSVG } from "base/assets/icons/korean-flag.svg";
import { useTranslation } from "react-i18next";

interface Props {
  isLoading: boolean;
  onChangeLanguage: (lang: "en" | "ko") => void;
}

const LanguagePopupContent = ({ isLoading, onChangeLanguage }: Props) => {
  const { t, i18n } = useTranslation();

  const renderSecondAction = (itemLang: string) => {
    if (!isLoading && itemLang === i18n.language) {
      return <Check fontSize="small" color="success" />;
    }

    if (isLoading) {
      return <Loader padding={0} size="smaller" />;
    }

    return null;
  };

  return (
    <List disablePadding>
      <ListItem disablePadding secondaryAction={renderSecondAction("en")}>
        <ListItemButton
          onClick={() => onChangeLanguage("en")}
          disabled={isLoading}
        >
          <ListItemIcon>
            <BaseSVGIcon>
              <EnglishFlagSVG />
            </BaseSVGIcon>
          </ListItemIcon>
          <ListItemText primary={"English"} />
        </ListItemButton>
      </ListItem>

      <ListItem disablePadding secondaryAction={renderSecondAction("ko")}>
        <ListItemButton
          onClick={() => onChangeLanguage("ko")}
          disabled={isLoading}
        >
          <ListItemIcon>
            <BaseSVGIcon>
              <KoreanFlagSVG />
            </BaseSVGIcon>
          </ListItemIcon>
          <ListItemText primary={"Korean"} />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default LanguagePopupContent;
